import { Component, Inject, LOCALE_ID, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkforceLayoutService } from 'src/app/workforce/workforce-layout.service';
import { WorkforceAppComponent } from 'src/app/workforce/app.wf.component';

@Component({
    selector: 'app-settings-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    standalone: false
})
export class SettingsBillingComponent {
  isSmallScreen$: Observable<boolean>;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private layoutService: WorkforceLayoutService,
    @Optional() public wfParent: WorkforceAppComponent | null
  ) {
    this.isSmallScreen$ = this.layoutService.isSmallScreen$;
  }

  toggleThinSidenav() {
    this.wfParent?.toggleThinSidenav();
  }
}
